import {
  createComponentClickedEvent,
  createScreenViewedEvent,
  track,
} from "@/analytics/events/base"

export const feedbackFormViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Analyze",
      from_screen: "Analyze",
    })
  )
}

export const feedbackSubmitClicked = ({
  message,
  canContact,
}: {
  message: string
  canContact: boolean
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Feedback",
      to_screen: "Analyze",
      component_type: "button",
      component_function: "user submits feedback",
      component_text: "Help us improve!",
      clicked_values: {
        feedback_message: message,
        user_allows_contact: canContact,
      },
    })
  )
}
